class UnknownError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LocalLogicTracking/UnknownError";
  }
}

export { UnknownError };
